module.exports = __webpack_public_path__ + "img/Highlight_Feature-A.2e824f72.png";